import React from 'react';
import PropTypes from 'prop-types';
import Collapsible from 'react-collapsible';
import {
  TooltipItem,
} from 'shared/components';

const CollapsibleStaffSection = (props) => {
  const { open, sectionTitle, staffList, children } = props;

  return (
    <Collapsible
      open={open}
      trigger={
        <div>
          <h6>
            {sectionTitle} ({staffList.length})
          </h6>
        </div>
      }
    >
      { children ?
          children :
          staffList.map((staff,idx) => (
            <div className="staff-row" key={`collapse-row-${staff.personnelId || idx}`}>
              <div className="text-ellipsis fw-bold">
                <TooltipItem item={`${staff.lastName}, ${staff.firstName}`}/>
              </div>
            </div>
          ))
      }
    </Collapsible>
  );
};

export default CollapsibleStaffSection;

CollapsibleStaffSection.propTypes = {
  open: PropTypes.bool,
  sectionTitle: PropTypes.string.isRequired,
  staffList: PropTypes.arrayOf(PropTypes.shape({})),
  children: PropTypes.node,
};

CollapsibleStaffSection.defaultProps = {
  children: null,
  open: true,
  staffList: [],
};
